goog.provide("shadow.js.shim.module$src$svg$artwork$data_viz_svg");
goog.provide("module$shadow_js_shim_module$src$svg$artwork$data_viz_svg");
shadow.js.shim.module$src$svg$artwork$data_viz_svg = shadow.js.nativeProvides["src/svg/artwork/data-viz.svg"] = shadow$bridge("src/svg/artwork/data-viz.svg");
module$shadow_js_shim_module$src$svg$artwork$data_viz_svg.default = shadow.js.shim.module$src$svg$artwork$data_viz_svg;
